export default "__VITE_ASSET__D1MyyCN$__"